import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette } from '../../../../theme';

const useStyles = makeStyles(() =>
  createStyles({
    helperText: {
      fontSize: 14,
      lineHeight: 1.2,
      fontWeight: 'normal',
      color: colorsPalette.violet,
    },
  }),
);
export default useStyles;
